/* ============================================
   DATA INDEX
   The Creative Orchestra - GEMINI Framework
   Central export for all data files
   ============================================ */

// Chapter metadata
import chaptersData from './chapters.json';

// Profile data
import profileData from './profile.json';

// Publications data
import publicationsData from './publications.json';

// Acknowledgements data
import acknowledgementsData from './acknowledgements.json';

// Work configurations
import geminiData from './works/gemini.json';
import genieData from './works/genie.json';
import midasData from './works/midas.json';
import magicsData from './works/magics.json';
import dimesData from './works/dimes.json';
import aegisData from './works/aegis.json';
import tracesData from './works/traces.json';
import euphoriaData from './works/euphoria.json';
import retinaData from './works/retina.json';
import fensoData from './works/fenso.json';

// Export chapter data
export const chapters = chaptersData;
export const chapterList = chaptersData.chapters;
export const novelParts = chaptersData.parts;
export const totalChapters = chaptersData.totalChapters;

// Export profile data
export const profile = profileData;

// Export publications data
export const publications = publicationsData;

// Export acknowledgements data
export const acknowledgements = acknowledgementsData;

// Export individual works
export const gemini = geminiData;
export const genie = genieData;
export const midas = midasData;
export const magics = magicsData;
export const dimes = dimesData;
export const aegis = aegisData;
export const traces = tracesData;
export const euphoria = euphoriaData;
export const retina = retinaData;
export const fenso = fensoData;

// Export works as collection
export const works = {
  gemini: geminiData,
  genie: genieData,
  midas: midasData,
  magics: magicsData,
  dimes: dimesData,
  aegis: aegisData,
  traces: tracesData,
  euphoria: euphoriaData,
  retina: retinaData,
  fenso: fensoData,
};

// Export works as array (ordered)
export const worksArray = [
  geminiData,
  genieData,
  midasData,
  magicsData,
  dimesData,
  aegisData,
  tracesData,
  euphoriaData,
  retinaData,
  fensoData,
];

/**
 * Get work by ID
 * @param {string} workId - Work identifier
 * @returns {Object|null} Work data or null
 */
export const getWorkById = (workId) => {
  return works[workId] || null;
};

/**
 * Get chapter by ID
 * @param {string} chapterId - Chapter ID (e.g., '01', '02')
 * @returns {Object|null} Chapter data or null
 */
export const getChapterById = (chapterId) => {
  return chapterList.find(ch => ch.id === chapterId) || null;
};

/**
 * Get chapters for a specific part
 * @param {number} partNumber - Part number
 * @returns {Array} Chapters in that part
 */
export const getChaptersByPart = (partNumber) => {
  const part = novelParts.find(p => p.number === partNumber);
  if (!part) return [];
  return part.chapterIds.map(id => getChapterById(id)).filter(Boolean);
};

/**
 * Get works by GEMINI stage
 * @param {string} stage - Stage name (Generation, Evaluation, Management, INspiration)
 * @returns {Array} Works in that stage
 */
export const getWorksByStage = (stage) => {
  return worksArray.filter(work => work.stage === stage);
};

// Default export
export default {
  chapters: chaptersData,
  profile: profileData,
  publications: publicationsData,
  acknowledgements: acknowledgementsData,
  works,
  worksArray,
  getWorkById,
  getChapterById,
  getChaptersByPart,
  getWorksByStage,
};
